import React, {
  // Component,
  Suspense,
  lazy,
  useEffect,
} from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import withClearCache from "./ClearCache";
import LazyLoad from "./Components/SuspenseFallback";
import "./App.css";
import Header from "./Components/Header";
import PrivateRoute from "./Helper/privateRoute";
import { useDispatch, useSelector } from "react-redux";
import { checkSessionAction } from "./Action/sessionAction";
import ClaimPendingList from "./Container/AllNotifClaimListPending";
import { useNotificationsClaimPending } from "./Hook/hookNotifClaim";
const Login = lazy(() => import("./Container/Login"));
const Home = lazy(() => import("./Container/Home"));
const Register = lazy(() => import("./Container/Register"));
const ChangePassword = lazy(() => import("./Container/ChangePassword"));
const ForgotPassword = lazy(() => import("./Container/ForgotPassword"));
// const VerifyMember = lazy(() => import("./Container/VerifyMember"));

// const BenefitList = lazy(() => import("./Container/BenefitList"));
// const PaymentList = lazy(() => import("./Container/PaymentList"));
// const PlanList = lazy(() => import("./Container/PlanList"));
// const RegistrationList = lazy(() => import("./Container/RegistrationList"));

const VerifyMember = lazy(() => import("./Container/VerifyMember"));
const TransactionReport = lazy(() => import("./Container/TransactionReport"));
const BenefitList = lazy(() => import("./Container/BenefitList"));
const PaymentList = lazy(() => import("./Container/PaymentList"));
const PlanList = lazy(() => import("./Container/PlanList"));
const RegistrationList = lazy(() => import("./Container/RegistrationList"));
const Reprint = lazy(() => import("./Container/Reprint"));
const Icd = lazy(() => import("./Container/Icd"));
const ChangePasswordForgot = lazy(
  () => import("./Container/ChangePasswordForgot"),
);
const UploadPdf = lazy(() => import("./Container/UploadPdf"));
const FaceRecognitionRegister = lazy(
  () => import("./Components/FaceRecognitionRegister"),
);
const FingerprintRegister = lazy(
  () => import("./Components/FIngerprintRegister"),
);
const ChangeUsername = lazy(() => import("./Container/ChangeUsername"));
const Formulir = lazy(() => import("./Container/Formulir"));
const UserMgt = lazy(() => import("./Container/UserMgt"));
const ClaimDetail = lazy(() => import("./Container/ClaimDetailsCashless"));
const CreateInvoice = lazy(() => import("./Container/CreateInvoice"));
const InvoiceDetail = lazy(() => import("./Container/InvoiceDetail"));

function MainApp() {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.isLogin.isLogin);
  const dataUser = JSON.parse(localStorage.getItem("LoginData"));
  // console.log(dataUser);

  const checkSession = (data) => {
    // console.log(data);
    dispatch(checkSessionAction({ id: dataUser.user_id }));
  };

  const handleFocus = () => {
    checkSession("window");
  };
  const handleVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      // Cek session login di sini
      checkSession("second");
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      // console.log("cek", isAuthenticated);
      window.addEventListener("focus", handleFocus);
      document.addEventListener("visibilitychange", handleVisibilityChange);

      // Optional: cek juga saat pertama kali komponen dimuat
      checkSession("first");
    }
    return () => {
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isAuthenticated]);

  //listener NotifClaimPending//
  function NotificationListener() {
    useNotificationsClaimPending();
    return null;
  }
  //listener NotifClaimPending//

  return (
    <BrowserRouter>
      <React.Fragment>
        {/* {isAuthenticated && <NotificationListener />} */}
        <Header />
        <Switch>
          <PrivateRoute
            path="/notification/claim"
            name="notification-claim"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                <ClaimPendingList {...props} />
              </Suspense>
            )}
          />
          <PrivateRoute
            path="/create-invoice"
            name="create-invoice"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                <CreateInvoice {...props} />
              </Suspense>
            )}
          />

          <PrivateRoute
            path="/invoice/:id"
            name="invoice-detail"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                <InvoiceDetail {...props} />
              </Suspense>
            )}
          />
          <PrivateRoute
            path="/claim/:id"
            name="claim-detail"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                <ClaimDetail {...props} />
              </Suspense>
            )}
          />
          <Route
            path="/login"
            name="login"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                {isAuthenticated ? (
                  <Redirect to={{ pathname: "/" }} />
                ) : (
                  <Login {...props} />
                )}
              </Suspense>
            )}
          />

          <PrivateRoute
            exact
            path="/"
            name="home"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                <Home {...props} />
              </Suspense>
            )}
          />
          <PrivateRoute
            exact
            path="/transactionReport"
            name="transactionReport"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                <TransactionReport {...props} />
              </Suspense>
            )}
          />

          <PrivateRoute
            exact
            path="/reprint"
            name="reprint"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                <Reprint {...props} />
              </Suspense>
            )}
          />

          <PrivateRoute
            exact
            path="/icd"
            name="icd"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                <Icd {...props} />
              </Suspense>
            )}
          />

          <PrivateRoute
            exact
            path="/changeUsername"
            name="changeUsername"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                <ChangeUsername {...props} />
              </Suspense>
            )}
          />

          <PrivateRoute
            exact
            path="/form"
            name="form"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                <Formulir {...props} />
              </Suspense>
            )}
          />
          <PrivateRoute
            exact
            path="/user-management"
            name="userManagement"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                <UserMgt {...props} />
              </Suspense>
            )}
          />

          <PrivateRoute
            exact
            path="/upload"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                <UploadPdf {...props} />
              </Suspense>
            )}
          />

          <PrivateRoute
            exact
            path="/changePassword"
            name="changePassword"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                <ChangePassword {...props} />
              </Suspense>
            )}
          />

          <Route
            path="/register"
            name="register"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                {isAuthenticated ? (
                  <Redirect to={{ pathname: "/" }} />
                ) : (
                  <Register {...props} />
                )}
              </Suspense>
            )}
          />

          <Route
            path="/forgotPassword"
            name="forgotPassword"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                {isAuthenticated ? (
                  <Redirect to={{ pathname: "/" }} />
                ) : (
                  <ForgotPassword {...props} />
                )}
              </Suspense>
            )}
          />

          <Route
            path="/changePasswordForgot/:token"
            name="changePasswordForgot"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                {isAuthenticated ? (
                  <Redirect to={{ pathname: "/" }} />
                ) : (
                  <ChangePasswordForgot {...props} />
                )}
              </Suspense>
            )}
          />
          <PrivateRoute
            exact
            path="/faceRecognitionRegister"
            name="faceRecognitionRegister"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                <FaceRecognitionRegister {...props} />
              </Suspense>
            )}
          />

          <PrivateRoute
            exact
            path="/fingerprintRegister"
            name="fingerprintRegister"
            component={(props) => (
              <Suspense fallback={<LazyLoad />}>
                <FingerprintRegister {...props} />
              </Suspense>
            )}
          />
        </Switch>
      </React.Fragment>
    </BrowserRouter>
  );
}

const ClearCacheComponent = withClearCache(MainApp);
function App() {
  return <ClearCacheComponent />;
}

export default App;
